import Link from 'next/link';
import Layout from '~/layouts/default';
import Seo from '~/components/seo';
import Header from '~/components/header';
import CodeCaption from '~/components/codeCaption';
import Advantages from '~/components/advantages';
import Advantage from '~/components/advantage';
import Packagist from '~/components/packagist';
import { getAppProxyUrl } from '~/helpers/url';

export default function Page() {
  return (
    <>
      <Layout>
        <Seo
          title="Proxy"
          description="Speed up downloading Composer dependencies by 90% thanks to global CDN"
          path="/proxy"
        />
        <section className="proxy">
          <div className="container">
            <article className="article">
              <Header primary freeTag>Proxy for Packagist</Header>
              <p className="text text__primary">
                Speed up downloading Composer dependencies by 90% thanks to global
                CDN. It works also for all packages from packagist.org
              </p>
            </article>
          </div>
        </section>
        <CodeCaption description="#use this composer plugin:">
          composer global require repman-io/composer-plugin
        </CodeCaption>
        <CodeCaption description="#or add this line to your composer.json file and trigger composer update --lock to update composer.lock file">
          {
`{
  "repositories": [
    {"type": "composer", "url": "${getAppProxyUrl()}"},
    {"packagist": false}
  ]
}`
}
        </CodeCaption>
        <Advantages>
          <Advantage>
            <Advantage.Header>
              Global CDN
            </Advantage.Header>
            <Advantage.Content>
              Speed up Composer up to 90%.
            </Advantage.Content>
          </Advantage>
          <Advantage>
            <Advantage.Header>
              Security
            </Advantage.Header>
            <Advantage.Content>
              Protect against removing a package from Packagist.
            </Advantage.Content>
          </Advantage>
          <Advantage>
            <Advantage.Header>
              Easy usage
            </Advantage.Header>
            <Advantage.Content>
              Just install the plugin or change your composer.json file.
            </Advantage.Content>
          </Advantage>
        </Advantages>
        <Packagist header="Private Packages">
          <p className="text text--light">
            Add and manage private PHP Composer dependencies in Cloud or behind your firewall.
            Dedicated integration with GitHub / GitLab and BitBucket.
          </p>
          <Link href="/">
            <a className="btn btn-primary">
              Go with repman
            </a>
          </Link>
        </Packagist>
      </Layout>
    </>
  );
}
